import React, { useState, useEffect, useCallback } from 'react';
import { Card } from 'primereact/card';
import { Button } from 'primereact/button';
import { Divider } from 'primereact/divider';

// PrimeReact 필수 CSS 스타일 (프로젝트 최상단 index.js / App.js에 있다면 생략 가능)
import 'primereact/resources/themes/lara-light-indigo/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import axios from 'axios';
import { Link } from 'react-router-dom';

const HomePage = () => {

	const [selectedCategory, setSelectedCategory] = useState('all');
	const [page, ] = useState(1);
	const [size, ] = useState(1000);
	const [latestPosts, setLatestPosts] = useState([]);
	const [categories, setCategories] = useState([]);

	const contentList = useCallback(async () => {
		const url = `https://ihongss.com/post/contentlist.json?page=${page}&size=${size}`
		const { data } = await axios.get(url);
		// console.log(data);
		if (data.result) {
			let arr = [];
			for (let post of data.docs) {
				arr.push({
					pid: post.pid,
					id: post.id,
					data: {
						title: post.title,
						description: post.description,
						pubDate: post.pubDate,
						category: post.category
					}
				});
			}

			setLatestPosts(arr);

			setCategories([
				...new Set(
					arr
						.map((post) => post.data.category || post.id.split('/')[0])
						.filter(Boolean)
				),
			]);
		}
	}, [page, size]);

		// 컴포넌트 마운트 시 브라우저 세션 스토리지에서 마지막 선택값 복구
	useEffect(() => {
		const savedCategory = sessionStorage.getItem('lastCategory');
		if (savedCategory) {
			setSelectedCategory(savedCategory);
		}
		contentList();
	}, [contentList]);

	// 카테고리 변경 핸들러
	const handleCategoryChange = (category) => {
		setSelectedCategory(category);
		sessionStorage.setItem('lastCategory', category);
	};

	// 선택된 카테고리에 맞춰 보여줄 게시글 필터링
	const filteredPosts = latestPosts.filter((post) => {
		if (selectedCategory === 'all') return true;
		const postCat = post.data.category || post.id.split('/')[0];
		return postCat === selectedCategory;
	});

	return (
		<div style={{ background: '#f5f7fa', minHeight: '100vh', color: '#222', fontFamily: 'Pretendard, sans-serif' }}>

			<header style={{
				background: '#111827',
				color: 'white',
				padding: '30px 60px',
				display: 'flex',
				justifyContent: 'space-between',
				alignItems: 'center'
			}}>
				<div>
					<h1 style={{ fontSize: '36px', margin: 0 }}>ihongss</h1>
					<p style={{ color: '#cbd5e1', margin: '5px 0 0 0' }}>AI · Backend · Frontend · Database · DevOps</p>
				</div>

				<div>
					<Link to="/login">
						<Button
							label="로그인"
							icon="pi pi-sign-in"
							className="p-button-outlined p-button-sm"
							style={{ color: '#cbd5e1', borderColor: '#4b5563', borderRadius: '8px' }}
						/>
					</Link>
				</div>
			</header>

			<div className="container" style={{ maxWidth: '1100px', width: '90%', margin: 'auto', padding: '40px 0' }}>

				<div style={{
					display: 'grid',
					gridTemplateColumns: typeof window !== 'undefined' && window.innerWidth > 800 ? '2fr 1fr' : '1fr',
					gap: '30px'
				}}>

					<div>
						<Card title={selectedCategory === 'all' ? '📌 최신글' : `📁 ${selectedCategory} 연구 글`} style={{ borderRadius: '12px', boxShadow: '0 2px 8px rgba(0,0,0,.08)' }}>
							{filteredPosts.length === 0 ? (
								<p>등록된 최신글이 없습니다.</p>
							) : (
								filteredPosts.map((post, index) => {
									const formattedDate = post.data.pubDate
										? new Date(post.data.pubDate).toLocaleDateString('ko-KR')
										: '';

									return (
										<div key={post.id}>
											<div style={{ padding: '15px 0' }}>
												<Link
													to={`/content?postId=${post.pid}`}
													style={{ fontSize: '20px', fontWeight: 'bold', color: '#2563eb', textDecoration: 'none' }}
												>
													{post.data.title}
												</Link>
												<p style={{ color: '#555', margin: '8px 0' }}>{post.data.description}</p>
												<small style={{ color: '#888' }}>{formattedDate}</small>
											</div>
											{/* 마지막 요소가 아닐 때만 구분선 생성 */}
											{index < filteredPosts.length - 1 && <Divider />}
										</div>
									);
								})
							)}
						</Card>
					</div>

					<div>
						<Card title="📚 카테고리" style={{ borderRadius: '12px', boxShadow: '0 2px 8px rgba(0,0,0,.08)' }}>
							{categories.length === 0 ? (
								<p>카테고리가 없습니다.</p>
							) : (
								<div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>

									<Button
										label="전체보기"
										className={`p-button-rounded ${selectedCategory === 'all' ? 'p-button-primary' : 'p-button-secondary p-button-outlined'}`}
										onClick={() => handleCategoryChange('all')}
										style={{ fontSize: '13px', padding: '6px 14px' }}
									/>

									{categories.map((category) => (
										<Button
											key={category}
											label={category}
											className={`p-button-rounded ${selectedCategory === category ? 'p-button-primary' : 'p-button-secondary p-button-outlined'}`}
											onClick={() => handleCategoryChange(category)}
											style={{ fontSize: '13px', padding: '6px 14px' }}
										/>
									))}

								</div>
							)}
						</Card>
					</div>

				</div>
			</div>

			<footer style={{ textAlign: 'center', padding: '40px', color: '#888' }}>
				© 2016 ihongss.com
			</footer>
		</div>
	);
}

export default HomePage;
